import { useFeaturePermissions } from '../Selectors/Permission';

export function useCanViewCases() {
  const featurePermissions = useFeaturePermissions();

  return (
    featurePermissions.caseWebBeta &&
    (featurePermissions.caseView || featurePermissions.createCases || featurePermissions.demoCase)
  );
}

export function useCanViewPerfusionDevices() {
  const featurePermissions = useFeaturePermissions();
  return featurePermissions.perfusionDevices && featurePermissions.perfusionDeviceRole !== null;
}

/** Only the Manager device role can add devices (the server treats Sales and above as Manager). */
export function useCanCreatePerfusionDevice() {
  const featurePermissions = useFeaturePermissions();
  return featurePermissions.perfusionDevices && featurePermissions.perfusionDeviceRole === 'Manager';
}

export function useCanUseUnosApi() {
  const featurePermissions = useFeaturePermissions();
  return featurePermissions.unosApi;
}

export function useCanUseUnosRecipients() {
  const featurePermissions = useFeaturePermissions();
  return featurePermissions.unosRecipientImport;
}
